module.exports = __webpack_public_path__ + "static/remotedoors-d34ae42e04f8e47f3affe0334655d03b.jpg";